import { supabase } from '../config/supabaseClient';

export interface SaleInput {
  date: string; // ISO date
  amount: number;
  currency?: string;
  product?: string;
  channel?: string;
  notes?: string;
}

export interface SaleRecord extends SaleInput {
  id: string;
  user_id: string;
  created_at: string;
}

export const salesService = {
  async create(sale: SaleInput): Promise<SaleRecord> {
    try {
      const { data: session } = await supabase.auth.getSession();
      const userId = session.session?.user?.id;
      if (!userId) throw new Error('Not authenticated');

      const payload = {
        user_id: userId,
        date: sale.date,
        amount: sale.amount,
        currency: sale.currency ?? 'GBP',
        product: sale.product ?? null,
        channel: sale.channel ?? null,
        notes: sale.notes ?? null,
      };

      const { data, error } = await supabase.from('sales_transactions').insert(payload).select().single();
      if (error) throw error;
      return data as SaleRecord;
    } catch (e: any) {
      console.error('salesService.create error', e);
      throw new Error(e?.message || 'Failed to save sale');
    }
  },

  async list(params: { from?: string; to?: string; limit?: number }): Promise<SaleRecord[]> {
    try {
      const { data: session } = await supabase.auth.getSession();
      const userId = session.session?.user?.id;
      if (!userId) throw new Error('Not authenticated');

      let query = supabase.from('sales_transactions').select('*').eq('user_id', userId).order('date', { ascending: false });
      if (params.from) query = query.gte('date', params.from);
      if (params.to) query = query.lte('date', params.to);
      if (params.limit) query = query.limit(params.limit);

      const { data, error } = await query;
      if (error) throw error;
      return (data || []) as SaleRecord[];
    } catch (e: any) {
      console.error('salesService.list error', e);
      // If table missing, return empty to avoid breaking UI
      return [];
    }
  }
};
